import StudentPage from "./StudentPage";

export default StudentPage;
